import React, { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import useEstimatedGenerationStyles from './styles'
import { Grid } from '@mui/material'
import CustomTextField from '../../../../components/CustomTextField/CustomTextField'

const EstimatedGeneration = ({ formik, Type, OgType, FormikFields, Edit }) => {
  const classes = useEstimatedGenerationStyles()
  const [commissionDate, setCommissionDate] = useState('') // Selected commission date
  const [estimatedData, setEstimatedData] = useState({}) // Object to store estimated data
  const [commissioninitialDate, setCommissioninitialDate] = useState(
    dayjs(new Date(formik?.values?.plantDetails?.commissionDate))
  )
  const [PreviousCommYear, setPreviousCommYear] = useState()
  const [NextCommYear, setNextCommYear] = useState()

  const [editData, setEditData] = useState(FormikFields)

  useEffect(() => {
    // Update the estimatedData with the existing edit data when commissionDate changes
    const newEstimatedData = {}
    for (const key in editData) {
      newEstimatedData[key] = editData[key]
    }
    setEstimatedData(newEstimatedData)
  }, [editData])

  useEffect(() => {
    const PreviousCommDate = new Date(
      formik?.values?.plantDetails?.commissionDate
    )
    const CommYear = PreviousCommDate.getFullYear()
    const NextYear = CommYear + 1
    setPreviousCommYear(CommYear)
    setNextCommYear(NextYear)
  }, [formik])

  useEffect(() => {
    const PreviousCommDate = new Date(
      formik?.values?.plantDetails?.commissionDate
    )

    setCommissionDate(PreviousCommDate)
    updateEstimatedData(PreviousCommDate) // Update estimated data when commission date changes
  }, [commissioninitialDate])

  const handleCommissionDateChange = (event) => {
    const selectedDate = new Date(event) // Convert input value to a Date object
    setCommissionDate(selectedDate)
    updateEstimatedData(selectedDate) // Update estimated data when commission date changes
  }

  const updateEstimatedData = (startDate) => {
    if (!startDate) {
      return
    }
    const PreviousCommyear = startDate.getFullYear()
    const PreviousCommmonth = startDate.getMonth()

    let Datamonths
    if (FormikFields != undefined && Object.keys(FormikFields).length > 0) {
      Datamonths = Object.keys(FormikFields?.[PreviousCommyear])
    }
    // return Datamonths.length > 0 && months[0] === "April";
    const Allmonths = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    if (
      FormikFields != undefined &&
      Object.keys(FormikFields).length > 0 &&
      Datamonths.length > 0 &&
      Datamonths[0] === Allmonths?.[PreviousCommmonth]
    ) {
      return
    } else {
      const startMonth = startDate.getMonth()
      const startYear = startDate.getFullYear()
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
      const newEstimatedData = {}

      let currentYear = startYear
      let currentMonth = startMonth

      for (let i = 0; i < 12; i++) {
        const monthName = months[currentMonth]
        if (!newEstimatedData[currentYear]) {
          newEstimatedData[currentYear] = {}
        }
        newEstimatedData[currentYear][monthName] = 0

        if (currentMonth === 11) {
          currentMonth = 0
          currentYear += 1
        } else {
          currentMonth += 1
        }
      }

      setEstimatedData(newEstimatedData)
    }
  }

  useEffect(() => {
    formik.setFieldValue(Type, estimatedData)
    formik.setFieldValue(OgType, estimatedData)
  }, [estimatedData])

  return (
    <div className={classes.root}>
      <div>
        <br />

        {Edit === true ? (
          <div>
            {Object.keys(estimatedData)
              .filter(
                (year) =>
                  year === `${PreviousCommYear}` || year === `${NextCommYear}`
              )
              .map((year) => (
                <div key={year}>
                  {/* {year}: */}
                  <Grid container spacing={2} className="mb_20" mt={2}>
                    {Object.keys(estimatedData[year]).map((monthYear) => (
                      <Grid key={monthYear} item xs={12} md={4} mt={2}>
                        <div>
                          <CustomTextField
                            label={`${monthYear}-${year}`}
                            id="filled-size-small"
                            type="number"
                            value={estimatedData[year][monthYear]}
                            onChange={(e) =>
                              setEstimatedData((prevData) => ({
                                ...prevData,
                                [year]: {
                                  ...prevData[year],
                                  [monthYear]: Number(e.target.value),
                                },
                              }))
                            }
                          />
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              ))}
          </div>
        ) : (
          <div>
            {Object.keys(estimatedData).map((year) => (
              <div key={year}>
                <Grid container spacing={2} className="mb_20" mt={2}>
                  {Object.keys(estimatedData[year]).map((monthYear) => (
                    <Grid key={monthYear} item xs={12} md={4} mt={2}>
                      <div>
                        <CustomTextField
                          label={`${monthYear}`}
                          id="filled-size-small"
                          type="number"
                          value={estimatedData[year][monthYear]}
                          onChange={(e) =>
                            setEstimatedData((prevData) => ({
                              ...prevData,
                              [year]: {
                                ...prevData[year],
                                [monthYear]: Number(e.target.value),
                              },
                            }))
                          }
                        />
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

EstimatedGeneration.propTypes = {}

export default EstimatedGeneration
